import { ArrowRight, Sparkles, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import featureFlags from '../config/featureFlags';

const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_18871752-f47d-441f-a8a8-9f91ef70c2b5/artifacts/fj0ur1wk_5306F759-961B-4E7A-9E69-254DA5C5344E.png";

const benefits = [
  "Professionelle Designs",
  "Deutschlandweiter Versand",
  "Zur Selbstmontage"
];

export const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.querySelector(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="start"
      className="relative min-h-screen flex items-center overflow-hidden noise-bg"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_IMAGE}
          alt="Fahrzeugbeklebung"
          className="w-full h-full object-cover"
        />
        {/* Stronger gradient overlay for readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/40" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 lg:py-0">
        <div className="max-w-2xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-8 animate-fadeInUp">
            <Sparkles className="w-4 h-4 text-teal-400" />
            <span className="text-sm font-medium text-white/90">Werbetechnik aus Weilburg</span>
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight leading-tight mb-6 animate-fadeInUp animation-delay-100">
            Professionelle Werbetechnik{' '}
            <span className="text-teal-400">zur Selbstmontage.</span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-white/80 mb-8 leading-relaxed animate-fadeInUp animation-delay-200">
            Individuelle Designs, druckfertige Folienlösungen und personalisierte Sticker – professionell gestaltet, deutschlandweit versendet.
          </p>

          {/* Benefits */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10 animate-fadeInUp animation-delay-300">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-center gap-2 text-white/90"
              >
                <CheckCircle2 className="w-5 h-5 text-teal-400 flex-shrink-0" />
                <span className="text-sm font-medium">{benefit}</span>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 animate-fadeInUp animation-delay-400">
            {featureFlags.SHOP_ENABLED ? (
              <Button
                onClick={() => scrollToSection('#sticker')}
                className="bg-teal-500 hover:bg-teal-400 text-slate-900 rounded-full px-8 py-6 text-base font-semibold shadow-lg transition-all active:scale-95"
                data-testid="hero-cta-primary"
              >
                Jetzt konfigurieren
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            ) : (
              <Button
                onClick={() => scrollToSection('#kontakt')}
                className="bg-teal-500 hover:bg-teal-400 text-slate-900 rounded-full px-8 py-6 text-base font-semibold shadow-lg transition-all active:scale-95"
                data-testid="hero-cta-primary"
              >
                Angebot anfragen
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            )}
            <Button
              onClick={() => scrollToSection('#leistungen')}
              variant="outline"
              className="bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 rounded-full px-8 py-6 text-base font-semibold transition-all"
              data-testid="hero-cta-secondary"
            >
              Unsere Leistungen
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden lg:block">
        <div className="w-6 h-10 rounded-full border-2 border-white/30 flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-white/50 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
};
